<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
/* 关闭 iOS Safari 的文字自动放大（text auto-inflation）。
   否则 iOS 真机会无视 CSS 字号、把部分文字块放大，撑破容器导致横向溢出，
   且该行为仅在 iOS 真机复现，桌面/Chrome/无痕均测不出来。 */
html {
  -webkit-text-size-adjust: 100%;
  text-size-adjust: 100%;
}
#app {
  font-family: Source Han Sans CN;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  background: #fff;
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue